export default __webpack_public_path__ + "static/media/checkbox-icon-blue.6f40d3f9.svg";